
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-tracking-software",
      function () {
        return require("private-next-pages/affiliate-tracking-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-tracking-software"])
      });
    }
  